import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RoleType } from 'src/app/Enums/usersFilterEnums';
import { RoleStatus } from 'src/app/Enums/roleEnum';
import { AuthService as EventAuthService } from '../services/Auth/auth.service';
import { AuthService } from '../services/Auth/business/auth.service';
import { ConstantsService } from '../services/Constants/constants.service';
import { DataContextService } from '../services/data-context.service';
import { InwardStatus } from 'src/app/Enums/inwardEnum';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent implements OnInit {
  private unsubscribe$ =new Subject<void>();
  userInitials: string;
  service_URL : any; 
  showUserDetails: boolean = false;
  userRole: string;
  userName: string;
  graphToken : any;  
  isImageLoading : boolean = false;
  imageToShow : any;
  userEmail: string;
  Image_Url: any;
  RoleStatus: RoleStatus;
  roleSuperAdmin: any;
  roleAdmin: any;
  roleSecuritySupervisor: any;
  roleUser: any;
  roleId : any;
  isRequestor: string;
  isL1: string;
  isL2: string;
  isApprover: string;
  isDenied: string;

  constructor(private _dataContextService: DataContextService,
    private _EventAuthService : EventAuthService,
    private _AuthService : AuthService,
    private domSanitizer : DomSanitizer) {

    this.roleSuperAdmin = RoleStatus.SuperAdmin;
    this.roleAdmin = RoleStatus.Admin;
    this.roleSecuritySupervisor = RoleStatus.SecuritySupervisior;
    this.roleUser = RoleStatus.User;
    
    this._EventAuthService.invokeEvent.subscribe(value=>this.logOut());
    this.service_URL = ConstantsService;

  }

  ngOnInit(): void {
  //  this._AuthService.invokeEvent.subscribe(value=>this.logOut());
   // this.userInitials = window['userInitial'].value;

    this.isDenied = localStorage.getItem('IsDenied');

    this.userName  =  localStorage.getItem('name');
    this.userEmail = localStorage.getItem('email');
    this.roleId = parseInt(localStorage.getItem('roleID'));

    this.isRequestor = localStorage.getItem('IsRequestor');
    this.isL1 = localStorage.getItem('IsL1');
    this.isL2 = localStorage.getItem('IsL2');
    this.isApprover = localStorage.getItem('IsApprover');

    // console.log(this.isRequestor,this.isL1,this.isL2,this.isApprover);

    // console.log(this.roleId);
   // this.userEmail = window['userName'].value;
    // this.userRole = localStorage.getItem('userRole');
    //console.log(this.userName);

    this.userRole = RoleStatus[this.roleId] === 'SecuritySupervisior' ? 'Security Supervisor' : RoleStatus[this.roleId];

    let firstName= this.userName.split(',')[0]?.trim();
    let lastName= this.userName.split(',')[1]?.trim();
    var firstletter= lastName.substring(0,1) + firstName.substring(0,1);
    this.userInitials = firstletter;

    this.getGraphToken();
  }
  getGraphToken(){
    this._dataContextService.postDatawithValues<any>(this.service_URL.Users.graphToken,null)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(result => {
          this.graphToken = result; 
          //this.getImage();       
        });
  }

  routeScreen(){
    if(this.roleId == this.roleAdmin || this.roleId == this.roleSuperAdmin || this.roleId == this.roleSecuritySupervisor){
      return '/OutwardSupervisor';
    }
    else if(this.isL1==='true' && this.isL2==='false' && this.roleId != this.roleSecuritySupervisor)
    {
      return '/OutwardL1Approver';
    }
    else if(this.isL2==='true' && this.roleId != this.roleSecuritySupervisor)
    {
      return '/OutwardL2Approver';
    }
  }

  showMyRequestsTab(){
    if(this.isRequestor === 'true'){
      return true;
    }
    return false;
  }

  showOutwardTab(){
    if(this.roleId == this.roleUser){
      if(this.isRequestor === 'true' && this.isApprover === 'false'){
        return false;
      }
      return true;
    }
    return true;
  }

  // getImage()
  // {
  //   this.isImageLoading = true;
  //   // this.userEmail='shshende@deloitte.com';
  //   //this._dataContextService.getImage('https://graph.microsoft.com/v1.0/users/' +'shshende@deloitte.com'+ '/photo/$value',this.graphToken)
  //   this._dataContextService.getImage('https://graph.microsoft.com/v1.0/users/' +this.userEmail+ '/photo/$value',this.graphToken)
  //   // .pipe(takeUntil(this.unsubscribe$))
  //   .subscribe((blob) => {
  //     this.isImageLoading = false;
  //     //this.userName  =  localStorage.getItem('name');

  //     var urlCreator = window.URL;
  //     this.imageToShow = this.domSanitizer.bypassSecurityTrustUrl(
  //       urlCreator.createObjectURL(blob)
  //     );
  //   },
  //   (error) => {
  //     this.isImageLoading = false;
  //     console.log(error);
  //   },
  //   () => {
  //     // Complete handler - called when EMPTY is returned (image not found)
  //     this.isImageLoading = false;
  //     console.log('Profile image not found, skipping...');
  //   }
  // );
  // }
  toggle() {
    this.showUserDetails = !this.showUserDetails;
  }

  logOut(){
    // Use AuthService logout method to properly clear session
    this._AuthService.logout();
  }
  downloadPrivacy(){
    window.open('https://my.dnet.deloitte.com/','_blank');
  }

  cookieRedirect(){
    window.open('https://cookienotice.deloitte.com','_blank');
  }
}
